var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.390625 0.729126H17.3646V19.6979H0.390625V0.729126Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 4.01038C9.39062 4.67183 10.125 5.78121 10.25 7.04163C10.6667 7.22913 11.1458 7.35933 11.6562 7.35933C13.5104 7.35933 15.0104 5.87496 15.0104 4.04163C15.0104 2.2135 13.5104 0.729126 11.6562 0.729126C9.83853 0.760375 8.33332 2.2135 8.33332 4.01038ZM6.1302 10.7656C7.98436 10.7656 9.48437 9.28121 9.48437 7.45308C9.48437 5.61975 7.98436 4.13538 6.1302 4.13538C4.28124 4.13538 2.77603 5.61975 2.77603 7.45308C2.77603 9.28121 4.28124 10.7656 6.1302 10.7656ZM7.53645 10.9895H4.6927C2.32812 10.9895 0.416656 12.8802 0.416656 15.2187V18.7239L0.635405 18.7864C2.87499 19.4791 4.85416 19.6979 6.45311 19.6979C9.58332 19.6979 11.401 18.8177 11.5312 18.7552L11.7552 18.625H11.7864V15.2187C11.8177 12.8802 9.90103 10.9895 7.53645 10.9895ZM13.0625 7.57808H10.25C10.2187 8.68225 9.73957 9.69267 8.97395 10.4218C11.0833 11.052 12.6146 12.9427 12.6146 15.2187V16.2604C15.3958 16.1666 16.9896 15.375 17.0885 15.3437L17.3125 15.2187H17.3437V11.8073C17.3437 9.47392 15.4271 7.57808 13.0625 7.57808Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerWhite);
export default __webpack_public_path__ + "static/media/customer-white.dacfcb3ef00d3bad1ee36820ca89f813.svg";
export { ForwardRef as ReactComponent };